import { render, staticRenderFns } from "./KitaAlefMessages.vue?vue&type=template&id=f8c72f1c&"
import script from "./KitaAlefMessages.vue?vue&type=script&lang=js&"
export * from "./KitaAlefMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports